<map-loading-overlay [loading]="mapDataIsLoading()" [showAfterMs]="100" />

<ev-salesmap-layout>
    <div slot="left-menu">
        @if(activeStage() != null) {
            <new-dwelling-stage-infocard [projectStage]="activeStage()"></new-dwelling-stage-infocard>
        }@else {
            <new-dwellings-list></new-dwellings-list>
        }
    </div>

    <div slot="right-menu-buttons">
        <map-right-menu-buttons [visibleButtons]="visibleButtons()" [canShowFreedrawButtons]="true"></map-right-menu-buttons>
    </div>
    <div slot="right-menu" class="right-menu">
        @if (selectedSidebar() === rightSidebarOptions.Filter) {
            <new-dwellings-filter></new-dwellings-filter>
        }
        @else if (selectedSidebar() === rightSidebarOptions.AreaBuilder) {
            <area-builder-sidebar-v2 [defaultAreaStructure] = "currentAreaStructure"></area-builder-sidebar-v2>
        }
        @else if (selectedSidebar() === rightSidebarOptions.Statistics) {
            <div class="statistics">
                <new-dwelling-statistics></new-dwelling-statistics>
            </div>
        }
        @else if (selectedSidebar() === rightSidebarOptions.Favorites && debugEnabled() ) {
            <div class="statistics">
                <new-dwelling-lists [projects]="sales()?.projects"></new-dwelling-lists>
            </div>
        }
    </div>
</ev-salesmap-layout>
